import { useMemo } from 'react';
import { walletMap } from '@blink/components/src/constants/wallet';
import { WALLET } from '@blink/components/src/types';

export const useInstalledWallets = () => {
    return useMemo(
        () => ({
            isMetaMaskWalletInstalled: walletMap.get(WALLET.META_MASK)?.isAvailable() || false,
            isRabbyBaseWalletInstalled: walletMap.get(WALLET.RABBY)?.isAvailable() || false,
        }),
        [],
    );
};
